import { mergeListItem } from "../helpers/listItemMerge";

const atualizarRequisicoesServico = (state, requisicoesServico) => {
    state.requisicoesServico = requisicoesServico;
}

const atualizarRequisicaoServico = (state, requisicaoServico) => {
    state.requisicaoServico = requisicaoServico;
}

const addRequisicaoServico = (state, requisicaoServico) => {
    if (!requisicaoServico || requisicaoServico.id == null) return;

    state.requisicoesServico.push(JSON.parse(JSON.stringify(requisicaoServico)));
    //alert(JSON.stringify(state.produtos));
}

const updateRequisicaoServico = (state, requisicaoServico) => {
    if (!requisicaoServico || requisicaoServico.id == null) return;

    const index = state.requisicoesServico.findIndex(item => item.id === requisicaoServico.id);
    if (index >= 0) {
        state.requisicoesServico.splice(index, 1, mergeListItem(state.requisicoesServico[index], requisicaoServico));
    }
    //alert(JSON.stringify(state.produtos));
}

export default {
    atualizarRequisicoesServico,
    atualizarRequisicaoServico,
    addRequisicaoServico,
    updateRequisicaoServico,
}
